module.exports = __webpack_public_path__ + "img/icon-credit.4002e42a.svg";